import React from "react";
import "./Dashboard.scss";
import { NavLink, Outlet } from "react-router-dom";
import listmneubar from "../../data/listmenubar";
import logoBanner from "../../assets/banner-hx.jpg";
const Dashboard = () => {
  return (
    <>
      <div className="main-dashboard">
        <div className="frame-button-sub-tab-dashboard">
          <div className="frame-brand-name">
            <img src={logoBanner} alt="banner-logo" />
          </div>

          <div className="frame-list-menu-bar">
            {listmneubar.map((item, index) => (
              <div key={index} className="frame-item-menu">
                <NavLink
                  to={item.link}
                  end={item.link === "/dashboard"}
                  className={({ isActive }) =>
                    isActive ? "item-menu-bar-active" : "item-menu-bar"
                  }
                >
                  <div
                    className={`frame-icon-menu ${item.icon.props.className}`}
                  >
                    {item.icon}
                  </div>
                  <span className="name-item-list">{item.name}</span>
                </NavLink>
              </div>
            ))}
          </div>
        </div>
        <div className="frame-view-sub-tab">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
